export interface LoadingAnimationProps {
  className?: string;
}

export default function LoadingAnimation({
  className = "",
}: LoadingAnimationProps) {
  return (
    <svg
      className={className}
      width="180"
      height="182"
      viewBox="0 0 180 182"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
    >
      <path
        d="M45.8231 67.5542C44.5846 65.4376 43.5274 63.2017 42.6212 60.9062C17.0364 76.6169 0 104.64 0 136.568C0 168.496 0 137.045 0 137.283H7.40057C7.40057 137.045 7.40057 136.806 7.40057 136.568C7.40057 107.561 22.7152 82.0724 45.8231 67.5542Z"
        fill="#F36221"
      />
      <path
        d="M55.8818 79.951C53.858 78.1623 52.0154 76.1947 50.2936 74.0781C29.3002 87.1654 15.375 110.24 15.375 136.563C15.375 162.887 15.375 137.04 15.375 137.279H23.3495C23.3495 137.04 23.3495 136.802 23.3495 136.563C23.3495 112.505 36.3987 91.4583 55.8818 79.951Z"
        fill="#F36221"
      />
      <path
        d="M71.1659 89.373C68.1151 88.1806 65.2455 86.69 62.5269 84.9609C43.7989 94.7689 31.082 114.176 31.082 136.565C31.082 158.953 31.082 137.042 31.082 137.28H38.7847C38.7847 137.042 38.7847 136.803 38.7847 136.565C38.7847 115.16 52.1963 96.8557 71.1961 89.373H71.1659Z"
        fill="#F36221"
      />
      <path
        d="M134.66 67.5542C135.868 65.4376 136.926 63.2017 137.832 60.9062C163.145 76.6169 180 104.64 180 136.568C180 168.496 180 137.045 180 137.283H172.66C172.66 137.045 172.66 136.806 172.66 136.568C172.66 107.561 157.496 82.0724 134.66 67.5542Z"
        fill="#F36221"
      />
      <path
        d="M124.695 79.951C126.689 78.1623 128.532 76.1947 130.223 74.0781C150.975 87.1654 164.779 110.24 164.779 136.563C164.779 162.887 164.779 137.04 164.779 137.279H156.895C156.895 137.04 156.895 136.802 156.895 136.563C156.895 112.505 143.997 91.4583 124.726 79.951H124.695Z"
        fill="#F36221"
      />
      <path
        d="M109.59 89.373C112.61 88.1806 115.45 86.69 118.138 84.9609C136.655 94.7689 149.251 114.176 149.251 136.565C149.251 158.953 149.251 137.042 149.251 137.28H141.639C141.639 137.042 141.639 136.803 141.639 136.565C141.639 115.16 128.378 96.8557 109.59 89.373Z"
        fill="#F36221"
      />
      <svg
        viewBox="0 0 800 800"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="-187"
          cy="400"
          fill="none"
          r="175"
          strokeWidth="35"
          stroke="#F36221"
          strokeDasharray="1400 1400"
          transform="rotate(-90)"
        >
          <animate
            attributeName="stroke-dashoffset"
            from="2800"
            to="0"
            dur="3s"
            repeatCount="indefinite"
            begin="0.3s"
          />
        </circle>
      </svg>
      <svg
        viewBox="0 0 800 800"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="-600"
          cy="400"
          fill="none"
          r="175"
          strokeWidth="35"
          stroke="#F36221"
          strokeDasharray="1400 1400"
          transform="rotate(-90)"
        >
          <animate
            attributeName="stroke-dashoffset"
            from="0"
            to="2800"
            dur="3s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </svg>
  );
}
